import type {ConditionParameters, IncludeExcludeParameters, TargetType} from '../types/rules-types'

export function isAllCondition(targetType: TargetType, parameters: ConditionParameters) {
  const params = parameters as IncludeExcludeParameters
  return (
    (targetType === 'repository_name' || targetType === 'organization_name') &&
    params.include.length === 1 &&
    params.include[0] === '~ALL' &&
    params.exclude.length === 0
  )
}
